module.exports = __webpack_public_path__ + "img/moti_1.f9b656fa.png";